module.exports = __webpack_public_path__ + "img/a1.4a47af46.png";